import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MainArea } from '../../../../../core/enums';
import { ApiAdapterServiceService } from '../../../../../core/services';
import { ConfirmationComponent } from '../../../../../global/confirmation/confirmation';
import { ConfirmationModel } from '../../../../../global/confirmation/shared/model';
import { PendingApprovalDialogViewComponent } from '../../dialog/pending-approval-dialog-view';
import { CampaignsListModel, TableModel } from '../../models';
import { CampaignResponseDtoApi } from '../../models/campaign-response-dto.model';

@Component({
	selector: 'lib-viewing-list-of-campaign-table',
	templateUrl: './viewing-list-of-campaign-table.component.html',
	styleUrls: ['./viewing-list-of-campaign-table.component.scss'],
})
export class ViewingListOfCampaignTableComponent implements OnInit, OnDestroy {
	@Output() currentView = new EventEmitter<MainArea>();

	@Output() updateTable = new EventEmitter<void>();

	private currentViews = MainArea;
	private subscribers: Subscription[] = [];

	@Input() public table: TableModel;

	@ViewChild(MatSort, { static: false }) public matSort: MatSort;

	constructor(
		private dialog: MatDialog,
		private apiAdapterService: ApiAdapterServiceService,
		private toastr: ToastrService
	) {}

	ngOnInit(): void {}

	public sort(): void {
		this.table.dataSource.sort = this.matSort;
	}

	public actionRow(row: CampaignsListModel, action: string): void {
		switch (action) {
			case 'pause':
				this.campaignConfirmationDialog(row.id, {
					title: 'Pause Campaign',
					content: 'Are you sure you want to Pause this Campaign?',
					url: `/campaign/${row.id}/pause`,
					method: 'POST',
					message: 'Selected campaign is successfully paused',
				});
				break;
			case 'stop':
				this.campaignConfirmationDialog(row.id, {
					title: 'Stop Campaign',
					content: 'Are you sure you want to Stop this Campaign?',
					url: `/campaign/${row.id}/stop`,
					method: 'POST',
					message: 'Selected campaign is successfully stop',
				});
				break;
			case 'delete':
				if (row.status !== 'COMPLETED') {
					this.campaignConfirmationDialog(row.id, {
						title: 'Delete Campaign',
						content:
							'Are you sure you want to Delete this Campaign?',
						url: `/campaign/${row.id}/delete`,
						method: 'DELETE',
						message: 'Selected campaign is successfully deleted',
					});
				}
				break;
			case 'live':
				this.campaignConfirmationDialog(row.id, {
					title: 'Resume Campaign',
					content: 'Are you sure you want to Resume this Campaign?',
					url: `/campaign/${row.id}/resume`,
					method: 'POST',
					message: 'Selected campaign is successfully resume',
				});
				break;
			default:
				break;
		}
	}

	private campaignConfirmationDialog(
		id: string,
		data: {
			title: string;
			content: string;
			url: string;
			method: string;
			message: string;
		}
	): void {
		const confirmation = new ConfirmationModel();
		confirmation.title = data.title;
		confirmation.content = data.content;
		confirmation.btnSubmit = 'Yes';
		confirmation.btnCancel = 'No';

		const subs = this.dialog
			.open(ConfirmationComponent, {
				autoFocus: false,
				backdropClass: 'overlay-backdrop-dialog',
				data: confirmation,
			})
			.afterClosed()
			.subscribe(resp => {
				if (!resp) return;

				this.campaignService(data);
			});

		this.subscribers.push(subs);
	}

	private campaignService(data: {
		url: string;
		method: string;
		message: string;
	}): void {
		const subs = this.apiAdapterService
			.executeApiRequest([], data.url, data.method)
			.subscribe(() => {
				this.toastr.error(data.message);
				this.updateTable.emit();
			});

		this.subscribers.push(subs);
	}

	editCampaign(row: CampaignsListModel): void {
		localStorage.removeItem('telin.campaign');
		window.history.replaceState({}, '', `/secure/campaign/${row.id}`);
		this.currentView.emit(this.currentViews.NewCampaign);
	}

	public openViewDialog(
		row: CampaignResponseDtoApi,
		isShowButton: boolean = false
	): void {
		localStorage.setItem(
			'telin.campaign',
			JSON.stringify({
				generalInformation: {
					id: row?.id,
					isShowButton: isShowButton,
				},
			})
		);

		const subs = this.dialog
			.open(PendingApprovalDialogViewComponent, {
				autoFocus: false,
				height: 'calc(100% - 30px)',
				width: 'calc(100% - 30px)',
				maxWidth: '100%',
				maxHeight: '100%',
				backdropClass: 'overlay-backdrop-dialog',
			})
			.afterClosed()
			.subscribe(() => {
				this.updateTable.emit();
			});

		this.subscribers.push(subs);
	}

	private convertUTCDateToLocalDate(date: Date) {
		const newDate = new Date(
			date.getTime() - date.getTimezoneOffset() * 60 * 1000
		);
		return newDate;
	}

	ngOnDestroy(): void {
		this.subscribers.forEach(each => each.unsubscribe());
	}
}
